export default __webpack_public_path__ + "static/media/ukraine-svgrepo-com.c78d5d2c.svg";